import * as actionTypes from './actionTypes';
import axios from '../../axios-orders';

export const initIngredients= (ing)=>{
    return {
        type:actionTypes.DEF_INGREDIENTS,
        ing:ing
    }
}

export const defIngredientsFailed=()=>{
    return {
        type:actionTypes.DEF_INGREDIENTS_FAILED
    }
}

export const defIngredients =()=>{
    return (dispatch)=>{
        axios.get('https://burger-builder-e562b.firebaseio.com/ingredients.json')
        .then(res=>{                                
            dispatch(initIngredients(res.data));
        })   
        .catch(err=>{
            dispatch(defIngredientsFailed())
        })
    }         

}
export const addIngredients =(ing,price)=>{
    return {
        type:actionTypes.ADD_INGREDIENTS,
        ing:ing,
        price:price
    }
}
export const remIngredients =(ing,price)=>{
    return {
        type:actionTypes.REM_INGREDIENTS,
        ing:ing,
        price:price
    }
}